import { CarePhase } from '@shared';
import {
  getPhaseInflationSchedule,
  PhaseInflationScheduleRow,
} from '@client/util/getPhaseInflationSchedule';

// With the claim-projection engine on, the phase inflation factor is the
// month-weighted AVERAGE of the phase's annually-stepped growth, so displays
// drop the year count and present the per-month schedule instead. Gated off,
// the schedule is empty and callers keep the legacy single-factor copy.
export function usePhaseInflationSchedule(
  client: Client,
  carePhase: CarePhase,
): { useMonthBasedGrowth: boolean; inflationSchedule: PhaseInflationScheduleRow[] } {
  const useMonthBasedGrowth = client.clientCalculationSettings?.useClaimProjectionEngine === true;
  const inflationSchedule = useMonthBasedGrowth
    ? getPhaseInflationSchedule(client, carePhase)
    : [];
  return { useMonthBasedGrowth, inflationSchedule };
}
